/** Shared requirement rules for threshold determination and exemption previews. */
export function chemicalThresholdState(input: {
  isEHS: boolean;
  compoundExceeds: boolean;
  mixtureExceeds: boolean;
  pureProductExceeds: boolean;
  appearsInMixture: boolean;
}) {
  const { isEHS, compoundExceeds, mixtureExceeds, pureProductExceeds, appearsInMixture } = input;
  return {
    reportingPossiblyRequired: isEHS ? compoundExceeds : compoundExceeds || mixtureExceeds,
    reportingUnavoidable: isEHS
      ? compoundExceeds
      : appearsInMixture
        ? (compoundExceeds && mixtureExceeds) || pureProductExceeds
        : compoundExceeds,
  };
}
